import { render, staticRenderFns } from "./Routes.vue?vue&type=template&id=1b14a415&"
import script from "./Routes.vue?vue&type=script&lang=ts&"
export * from "./Routes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports